import APIClient from '@/shared/http/clients/api'

const resourceName = 'card/cobranca'
const resourceNameCob = 'cobranca'
const APICore = process.env.APIBaseURLCore

const GetAll = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?situacao=ATIVO&page=${index}&size=${limit}&sort=posicao`, config)
const Search = (situacao = 'ATIVO', filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/?situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}`, config)
const RefreshDashboard = (situacao = 'ATIVO', filter = '', config = {}) => APIClient.get(`${APICore}/${resourceName}-dashboard/?situacao=${situacao}${filter != null ? filter : ''}`, config)

const RefreshUpdatesDashboard = (evento, config = {}) => APIClient.get(`${APICore}/${resourceNameCob}/?tipoCobrancaEvento=${evento}`, config)
const SearchUpdates = (evento, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceNameCob}/?tipoCobrancaEvento=${evento}&page=${index}&size=${limit}`, config)

const CobrancaCardRepository = {
  GetAll,
  Search,
  RefreshDashboard,
  RefreshUpdatesDashboard,
  SearchUpdates
}

export default CobrancaCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/cardCobranca.js